import React from "react";
import Select from "../../comman/select";
import PasswordInput from "../../comman/PasswordInput";
import PhoneInput from "../../comman/PhoneInput";
import Input from "../../comman/input";
import TextArea from "../../comman/textarea";

const useControls = (data, errors, handleChange, schema, handleFocus) => {
  const renderInput = (
    name,
    label,
    type = "text",
    size,
    disabled = false,
    min = 0,
    max,
    icon,
  ) => {
    if (type === "password") {
      return (
        <PasswordInput
          name={name}
          value={data[name] || ""}
          label={label}
          onChange={handleChange}
          error={errors[name]}
          req={schema[name]}
          disabled={disabled}
          autoComplete="new-password"
        />
      );
    } else if (type === "phone") {
      return (
        <PhoneInput
          name={name}
          value={data[name] || ""}
          label={label}
          onChange={handleChange}
          error={errors[name]}
          req={schema[name]}
          disabled={disabled}
          icon={icon}
        />
      );
    } else if (type === "number") {
      return (
        <Input
          type="number"
          name={name}
          value={data[name] || ""}
          label={label}
          onChange={handleChange}
          error={errors[name]}
          onFocus={handleFocus}
          req={schema[name]}
          min={min}
          max={max}
          disabled={disabled}
          icon={icon}
        ></Input>
      );
    } else {
      return (
        <Input
          type={type}
          name={name}
          value={data[name] || ""}
          label={label}
          onChange={handleChange}
          error={errors[name]}
          onFocus={handleFocus}
          req={schema[name]}
          size={size}
          disabled={disabled}
          icon={icon}
          autoComplete={name === "username" ? "off" : undefined}
        ></Input>
      );
    }
  };

  const renderSelect = (name, label, options, optName, optValue, icon) => {
    return (
      <Select
        name={name}
        value={data[name] || ""}
        label={label}
        options={options}
        onChange={handleChange}
        error={errors[name]}
        optName={optName}
        optValue={optValue}
        req={schema[name]}
        icon={icon}
      />
    );
  };

  const renderTextArea = (name, label, icon) => {
    return (
      <TextArea
        name={name}
        value={data[name] || ""}
        label={label}
        onChange={handleChange}
        error={errors[name]}
        req={schema[name]}
        icon={icon}
      ></TextArea>
    );
  };

  return {
    renderSelect,
    renderInput,
    renderTextArea,
  };
};

export default useControls;
